import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StatusModalComponent } from '../../shared/components/status-modal/status-modal.component';
import { StatusModalData } from '../../shared/models/status-modal.model';

@Injectable({
  providedIn: 'root',
})
export class StatusModalService {
  private readonly dialog = inject(MatDialog);

  public open(data: StatusModalData): void {
    this.dialog.open(StatusModalComponent, {
      data,
      panelClass: 'status-modal-panel',
      autoFocus: false,
      restoreFocus: true,
    });
  }
}
